/**
 * The wall, while an answer is still out (job #895, ask 681).
 *
 * Tom, 2026-10-21: "we give benefit of the doubt access to anyone who's
 * entering an email ... if they then try to go beyond the paywall, they'll be
 * told they need to upgrade if they haven't been proven to be in the old
 * database by then". So a learner the old SSi app has never answered for is
 * not shown the upgrade page at the preview edge: the player HOLDS, exactly as
 * it does while the subscription answer is out, and asks the old app there.
 * A yes lowers nothing because nothing was raised; play carries on. A no
 * raises the wall with the upgrade page. Our own failure to ask is the server's
 * provisional grant (legacySsiGrant.ts), so it carries on too.
 */
export interface WallInputs {
  /** The subscription / entitlement answer is not in yet (job #895). */
  accessPending: boolean
  /** The old app has never answered for this learner (ask 681). */
  oldAppPending: boolean
}

export interface WallStep {
  /** Hold at the edge, no wall, until neither answer is out. */
  hold: boolean
  /** Ask the old app now (useUserEntitlements.settleOldApp). */
  settle: boolean
}

export function wallStep(s: WallInputs): WallStep {
  return { hold: s.accessPending || s.oldAppPending, settle: s.oldAppPending }
}
